module.exports = __webpack_public_path__ + "img/visa.2f7c39be.png";